import { ApiCategoryIndustries, ApiCategoryIndustry } from '../api-types/category-industries.api';
import { CategoryIndustries, CategoryIndustry } from '../app-types/category-industries.app';

/**
 * Transforms an Api object to an app-specific CategoryIndustries object.
 * @description This function maps properties of the ApiCategoryIndustries to the CategoryIndustries interface.
 * It is used to convert data received from the API into a format that the application can work with.
 * @param input ApiCategoryIndustries
 * @returns CategoryIndustries
 */
export const transformApiIndustryToAppIndustry = (
	input: ApiCategoryIndustry | undefined,
): CategoryIndustry | undefined => {
	return input;
};

export const transformApiIndustriesToAppIndustries = (input: ApiCategoryIndustries): CategoryIndustries => {
	return input ?? [];
};
